export default __webpack_public_path__ + "static/6_19-f297be8b0cec8825f5d39fe0004449e1.png";